import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "button"
}
const _hoisted_3 = {
  key: 1,
  class: "status-bar"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "header-cell" }
const _hoisted_6 = ["onUpdate:modelValue", "onFocus", "onKeydown", "onInput"]
const _hoisted_7 = {
  key: 0,
  class: "error-mark"
}

import { ref, onUnmounted } from "vue";

// 10x10 のグリッドを初期化

export default /*@__PURE__*/_defineComponent({
  __name: 'MasTraining',
  setup(__props) {

const grid = ref(Array.from({ length: 10 }, () => Array(10).fill("")));

// 行と列の数字（1~9の範囲でランダムに設定）
const rowNumbers = ref(
  Array.from({ length: 10 }, () => Math.floor(Math.random() * 9) + 1)
);
const columnNumbers = ref(
  Array.from({ length: 10 }, () => Math.floor(Math.random() * 9) + 1)
);

// 結果（正誤判定）を格納
const results = ref(Array.from({ length: 10 }, () => Array(10).fill(true)));

// タイマー管理
const startTime = ref<number | null>(null);
const timer = ref<ReturnType<typeof setInterval> | null>(null); // 型を指定
const elapsedTime = ref<string>("");

// ゲーム状態管理
const isStarted = ref(false); // スタート前はマスを非表示

// タイマーを開始
const startCalculation = () => {
  isStarted.value = true; // スタート時にマスを表示
  startTime.value = Date.now();
  elapsedTime.value = "0分0秒";
  grid.value = Array.from({ length: 10 }, () => Array(10).fill(""));

  // タイマーを定期的に更新
  if (timer.value) {
    clearInterval(timer.value);
  }
  timer.value = setInterval(() => {
    if (startTime.value) {
      const now = Date.now();
      const totalSeconds = Math.floor((now - startTime.value) / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      elapsedTime.value = `${minutes}分${seconds}秒`;
    }
  }, 1000);
};

const resetCalculation = () => {
  isStarted.value = false;
  elapsedTime.value = "0分0秒";
  grid.value = Array.from({ length: 10 });
};

// 答え合わせ
const submitCalculation = () => {
  if (!startTime.value) {
    alert("計算を開始してください！");
    return;
  }

  // 正誤判定
  results.value = grid.value.map((row, rowIndex) =>
    row.map((cell, colIndex) => {
      const correctAnswer =
        rowNumbers.value[rowIndex] + columnNumbers.value[colIndex];
      return parseInt(cell, 10) === correctAnswer;
    })
  );

  // 正解数をカウント
  const correctCount = results.value
    .flat()
    .filter((isCorrect) => isCorrect).length;

  // タイマーを停止
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }

  alert(
    `計算結果を確認してください！\n正解数: ${correctCount}点\n経過時間: ${elapsedTime.value}`
  );
};

// クリーンアップ（コンポーネントが破棄されたとき）
onUnmounted(() => {
  if (timer.value) {
    clearInterval(timer.value);
  }
});

// 入力バリデーション（1~9 の範囲に制限）
const validateInput = (row: number, col: number) => {
  let value = grid.value[row][col];
  if (!/^\d{1,3}$/.test(value)) {
    grid.value[row][col] = ""; // 不正な入力をクリア
  }
};

// 入力時に全角を半角に変換
const setInputToHalfWidth = (row: number, col: number) => {
  const inputElement = document.querySelector(
    `input[tabindex="${row * 10 + col}"]`
  ) as HTMLInputElement;
  if (inputElement) {
    inputElement.style.fontFamily = "monospace";
  }
};

// 正誤判定
const isIncorrect = (row: number, col: number) => {
  return !results.value[row][col];
};

// キー操作（矢印キーやBackspaceに対応）
const handleKeydown = (event: KeyboardEvent, row: number, col: number) => {
  const inputElements = document.querySelectorAll("input");
  const index = row * 10 + col;
  switch (event.key) {
    case "ArrowUp":
      if (row > 0) {
        (inputElements[index - 10] as HTMLInputElement).focus();
      }
      break;
    case "ArrowDown":
      if (row < 9) {
        (inputElements[index + 10] as HTMLInputElement).focus();
      }
      break;
    case "ArrowLeft":
      if (col > 0) {
        (inputElements[index - 1] as HTMLInputElement).focus();
      }
      break;
    case "ArrowRight":
      if (col < 9) {
        (inputElements[index + 1] as HTMLInputElement).focus();
      }
      break;
    case "Backspace":
      grid.value[row][col] = "";
      break;
    default:
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", null, "100マス計算", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("b", null, "足し算", -1)),
    (!isStarted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", { onClick: startCalculation }, "スタート")
        ]))
      : _createCommentVNode("", true),
    (isStarted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, "時間経過: " + _toDisplayString(elapsedTime.value), 1),
          _createElementVNode("button", { onClick: resetCalculation }, "最初からやり直す"),
          _createElementVNode("button", { onClick: submitCalculation }, "答え合わせ")
        ]))
      : _createCommentVNode("", true),
    (isStarted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("th", null, "+", -1)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (col) => {
                  return _createElementVNode("th", { key: col }, _toDisplayString(columnNumbers.value[col - 1]), 1)
                }), 64))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (row) => {
                return _createElementVNode("tr", { key: row }, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(rowNumbers.value[row - 1]), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (col) => {
                    return _createElementVNode("td", {
                      key: col,
                      class: "cell"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: "3",
                        "onUpdate:modelValue": ($event: any) => ((grid.value[row - 1][col - 1]) = $event),
                        class: _normalizeClass({ incorrect: isIncorrect(row - 1, col - 1) }),
                        tabindex: "0",
                        inputmode: "numeric",
                        onFocus: ($event: any) => (setInputToHalfWidth(row - 1, col - 1)),
                        onKeydown: ($event: any) => (handleKeydown($event, row - 1, col - 1)),
                        onInput: ($event: any) => (validateInput(row - 1, col - 1))
                      }, null, 42, _hoisted_6), [
                        [_vModelText, grid.value[row - 1][col - 1]]
                      ]),
                      (isIncorrect(row - 1, col - 1))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "✖"))
                        : _createCommentVNode("", true)
                    ])
                  }), 64))
                ])
              }), 64))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})